
const getGameClientId = () => {

    // "76223a82-463e-4e26-a2f4-d1c86e6ba39b" // lower envs
    // "82c8e1bb-4e48-4ca5-a5fb-7d986b35b3a2" //prod

    // PDG clientID
    if (window.location.host.includes('op')) {
        if (window.location.host.includes('preprod')) {
            return "76223a82-463e-4e26-a2f4-d1c86e6ba39b"
        } else if (window.location.host.includes('prod')) {
            return "82c8e1bb-4e48-4ca5-a5fb-7d986b35b3a2"
        } else {
            return "76223a82-463e-4e26-a2f4-d1c86e6ba39b"
        }
    }
    
    // PCF clientID
    if (window.location.host.includes('prod')) {
        return "82c8e1bb-4e48-4ca5-a5fb-7d986b35b3a2"
    } else {
        return "76223a82-463e-4e26-a2f4-d1c86e6ba39b"
    }

}

const getGameClientSecret = () => {

    // "EGuGP2380DwpWWLyJRiS9DpqOanJ13EmX3PQ8zeTdwM=" // lower envs
    // "6yHPi11xK2LNGtgboMXhsJozojyg9cZh64vMoTj6Qrc=" //prod

    // PDG Client Secret
    if (window.location.host.includes('op')) {
        if (window.location.host.includes('preprod')) {
            return "EGuGP2380DwpWWLyJRiS9DpqOanJ13EmX3PQ8zeTdwM="

        } else if (window.location.host.includes('prod')) {
            return "6yHPi11xK2LNGtgboMXhsJozojyg9cZh64vMoTj6Qrc="
        } else {
            return "EGuGP2380DwpWWLyJRiS9DpqOanJ13EmX3PQ8zeTdwM="
        }
    }
    
    // PCF Client Secret
    if (window.location.host.includes('prod')) {
        return "6yHPi11xK2LNGtgboMXhsJozojyg9cZh64vMoTj6Qrc="

    } else {
        return "EGuGP2380DwpWWLyJRiS9DpqOanJ13EmX3PQ8zeTdwM="
    }
}

const getGameRedirectUrl = () => {

    // PDG redirect
    if (window.location.host.includes('op')) {
        if (window.location.host.includes('preprod')) {
            return "https://telemetry-ui-preprod.op12pdg1.gm.com/"

        } else if (window.location.host.includes('prod')) {
            return "https://telemetry-ui-prod.op12pdg1.gm.com/"

        } else if (window.location.host.includes('qa')) {
            return "https://telemetry-ui-qa.op-epg1mi.gm.com"

        } else if (window.location.host.includes('test')) {
            return "https://telemetry-ui-test.op-epg1mi.gm.com"

        } else {
            return "https://telemetry-ui-dev.op-epg1mi.gm.com"
        }
    }
    
    // PCF redirect
    if (window.location.host.includes('prod')) {
        return "https://visualization-telemetry-prod.apps.pcfepg3mi.gm.com/"

    } else if (window.location.host.includes('test')) {
        return "https://visualization-telemetry-test.apps.pcfepg3mi.gm.com/"

    } else if (window.location.host.includes('qa')) {
        return "https://visualization-telemetry-qa.apps.pcfepg3mi.gm.com/"

    } else {
        return "https://visualization-telemetry-dev.apps.pcfepg3mi.gm.com/"
    }
}

const getGameAuthority = () => {

    // PDG Game Authority
    if (window.location.host.includes('op')) {
        if (window.location.host.includes('preprod')) {
            return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/authorize"

        } else if (window.location.host.includes('prod')) {
            return "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/authorize"
        } else {
            return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/authorize"
        }
    }
    
    // PCF Game Authority
    if (window.location.host.includes('prod')) {
        return "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/authorize"

    } else {
        return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/authorize"
    }
}

const getGameTokenEndpoint = () => {

    // PDG Game Token Endpoint
    if (window.location.host.includes('op')) {
        if (window.location.host.includes('preprod')) {
            return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/token"

        } else if (window.location.host.includes('prod')) {
            return "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/token"
        } else {
            return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/token"
        }
    }
    
    // PCF Game Token Endpoint
    if (window.location.host.includes('prod')) {
        return "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/token"

    } else {
        return "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d/oauth2/v2.0/token"
    }
}

export {getGameClientId, getGameClientSecret, getGameRedirectUrl, getGameAuthority, getGameTokenEndpoint}